// extracted by mini-css-extract-plugin
module.exports = {"border-gray":"#ddd","heading":"Heading-module__heading___uJmzA","badge":"Heading-module__badge___3dCsq"};